// 处理数字相关

import { abbreviations } from './config';

export function computeAverage(value) {
  let remainder = value;
  let abbr = '';
  const abs = Math.abs(value);
  const billion = Math.pow(10, 9);
  const million = Math.pow(10, 6);
  const thousand = Math.pow(10, 3);

  if (abs >= billion) {
    abbr = abbreviations['billion'];
    remainder = abs / billion;
  } else if (abs < billion && abs >= million) {
    abbr = abbreviations['million'];
    remainder = abs / million;
  } else if (abs < million && abs >= thousand) {
    abbr = abbreviations['thousand'];
    remainder = abs / thousand;
  }

  return { remainder, abbr };
}

// 获取当前数的最大整数
export function getMaxIntByNumber(number) {
  const abs = Math.ceil(Math.abs(number));
  const digit = abs.toString().length;
  const times = Math.pow(10, digit - 1);
  const remainder = abs / times;
  const value = Math.ceil(remainder) * times;
  return value;
}

export function getMaxIntByList(array) {
  const max = array.length > 0 ? Math.max.apply(null, array) : 0;
  return getMaxIntByNumber(max);
}

export function getMinIntByList(array) {
  const min = array.length > 0 ? Math.min.apply(null, array) : 0;
  return min < 0 ? 0 - getMaxIntByNumber(min) : 0;
}

// 分转元
export function fenToYuan(value) {
  if (!value) return 0;
  return parseInt(value, 10) / 100;
}
